import * as React from "react";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricGrid } from "@/components/dashboard/MetricGrid";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { usePerformanceMetrics } from "@/hooks/queries/useAnalytics";
import { appConfig } from "@/utils/config";

interface PerformanceMetricsPayload {
  risk: { sharpe_ratio: number; sortino_ratio: number; maximum_drawdown: number } | null;
}

/**
 * Backend v2.1 (Sprint 4.3) `GET /api/v1/analytics/performance` - a
 * dedicated read of the same persisted snapshot's performance/risk
 * fields only (a narrower response than `GET /analytics`, reused here
 * since Risk Metrics needs only the `risk` object).
 */
export function RiskMetricsSection(): React.JSX.Element {
  const performanceQuery = usePerformanceMetrics(appConfig.defaultPortfolioId);

  return (
    <StatusCard title="Risk Metrics">
      <QueryStateBoundary query={performanceQuery}>
        {(payload) => {
          const performance = payload as unknown as PerformanceMetricsPayload;
          return (
            <MetricGrid
              metrics={[
                { label: "Maximum Drawdown", value: performance.risk?.maximum_drawdown ?? null },
                { label: "Sharpe Ratio", value: performance.risk?.sharpe_ratio ?? null },
                { label: "Sortino Ratio", value: performance.risk?.sortino_ratio ?? null },
              ]}
            />
          );
        }}
      </QueryStateBoundary>
    </StatusCard>
  );
}
